var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.75,
    height: 18.76,
    viewBox: "0 0 18.75 18.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M366.319,1285.03l-6.087-6.09a7.07,7.07,0,1,0-1.294,1.29l6.087,6.09a.165.165,0,0,0,.062.04.147.147,0,0,0,.148,0,.165.165,0,0,0,.062-.04l1.022-1.02a.237.237,0,0,0,.041-.06.227.227,0,0,0,.015-.08.177.177,0,0,0-.015-.07A.236.236,0,0,0,366.319,1285.03Zm-7.95-6.66a5.258,5.258,0,1,1,1.537-3.71A5.231,5.231,0,0,1,358.369,1278.37Z",
    transform: "translate(-347.625 -1267.62)",
    fill: "#81868b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.48d656b5f20b5b132426a90fd95aa6c5.svg";
export { ForwardRef as ReactComponent };